import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useShop } from "@/contexts/ShopContext";
import { toast } from "sonner";

export default function AcceptOnline() {
  const { currentShopId } = useShop();
  const [orders, setOrders] = useState([]);

  const load = useCallback(async () => {
    if (!currentShopId) return;
    const { data } = await api.get("/accept-online", { params: { shop_id: currentShopId } });
    setOrders(data);
  }, [currentShopId]);

  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    const id = setInterval(load, 8000);
    return () => clearInterval(id);
  }, [load]);

  const accept = async (id) => {
    await api.post(`/orders/${id}/accept`);
    toast.success("Order accepted");
    load();
  };
  const reject = async (id) => {
    await api.post(`/orders/${id}/reject`);
    toast("Order rejected");
    load();
  };

  return (
    <section className="view" data-testid="accept-online-page">
      <div className="page-head">
        <div>
          <div className="eyebrow">Front desk · payment gate</div>
          <h1>Accept Online Order</h1>
          <p>Payment and acceptance happen here before the ticket hits the line.</p>
        </div>
        <span className="status pending" data-testid="waiting-count">{orders.length} waiting</span>
      </div>
      <div className="queue-grid">
        {orders.map((o) => (
          <div className="card queue-card" key={o.id} data-testid={`accept-card-${o.order_number}`}>
            <div className="queue-top">
              <div><strong>#{o.order_number} · {o.customer_name}</strong><small>Online</small></div>
              <span className="status pending">Pending</span>
            </div>
            <div className="line-items">
              {o.lines.map((l) => (
                <div className="line" key={l.item_id}>{l.name}<small>× {l.qty}</small></div>
              ))}
            </div>
            <div className="ticket-total" style={{ margin: "0 16px 14px", paddingTop: 12 }}>
              <span className="field-label">Total</span><strong className="mono">₹{o.total}</strong>
            </div>
            <div className="queue-footer">
              <button className="btn btn-primary" onClick={() => accept(o.id)} data-testid={`accept-btn-${o.order_number}`}>✓ Paid &amp; Accept</button>
              <button className="btn btn-secondary" onClick={() => reject(o.id)} data-testid={`reject-btn-${o.order_number}`}>Reject</button>
            </div>
          </div>
        ))}
        {orders.length === 0 && <div className="card" style={{ padding: 30, gridColumn: "1/-1" }} data-testid="no-pending-orders">No online orders waiting right now.</div>}
      </div>
    </section>
  );
}